module.exports = __webpack_public_path__ + "static/media/maternity4.929497eb.jpg";